// extracted by css-extract-rspack-plugin
export default {"transition":"_4c0fb08a"};